import {
  Button,
  IconButton,
  TextField,
  Typography,
  Box,
  Tooltip,
} from "@mui/material";
import {
  Grid,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
} from "@material-ui/core";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
//import { BootstrapInput } from "../../../Utilities/utility";
import EditIcon from "@mui/icons-material/Edit";
import { DataGrid } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import DownloadIcon from "@mui/icons-material/Download";
import React, { useState, useEffect, useCallback } from "react";
import UpdateUploadDrawing from "./update_upload";
import SnackbarCustom from "../../components/Snackbar/Snackbar";
import { useSelector, useDispatch } from "react-redux";
import {
  factoryList,
  searchFactoryList,
  exportQuotationBasedOnFactoryList,
  deleteQuotation,
} from "../../redux/API/api_uploadDrawing";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
// import NonStandardMLFBDialog from "./non-standard-mlfb-dialog";
// import { zcodesData } from "../../../redux/Actions/actions";
import GreenSignal from "../../assets/images/GreenSignal.jpg";
import RedSignal from "../../assets/images/RedSignal.jpg";
import YellowSignal from "../../assets/images/YellowSignal.jpg";

export default function UploadDrawing() {
  const statusMapping = {
    1: { text: "In process / New", img: RedSignal },
    2: { text: "Drawing Pending with AW – design", img: YellowSignal },
    3: { text: "Drawing submitted / Completed", img: GreenSignal },
  };
  const [editQuotation, setEditQuotation] = useState(false);

  const [rows, setRows] = useState();
  const [initialRows, setInitialRows] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [open, setOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [alertType, setAlertType] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [searchText, setSearchText] = useState("");
  const UID = useSelector((state) => state.saveUserIdReducer);
  const userdetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const siteToken = useSelector((state) => state.saveTokenReducer);
  const azureToken = useSelector((state) => state.saveAzureTokenReducer);
  const [openForDelete, setOpenForDelete] = useState(false);
  const [deleteUser, setDeleteUser] = useState([]);
  const [category, setCategory] = useState([]);
  const [referNo, setRefNo] = useState("");
  const [quatationRefNo, setQuatationRefNo] = useState("");
  const [initiatorName, setInitiatorName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [quotationId, setQuotationId] = useState("");
  const [quotationDetailId, setQuotationDetailId] = useState("");
  const dispatch = useDispatch();
  const [selectedValues, setSelectedValues] = useState({
    refno: "",
    initiator: "",
    customer: "",
  });

  const columns = [
    {
      field: "quotationRefNo",
      headerName: "Quotation Reference Number",
      flex: 0.5,
      sortable: false,
      width: "20px",
      gap: "20px",
      renderCell: (params) => (
        <div>
          <span
            style={{ cursor: "pointer", color: "blue" }}
            onClick={() => handleEditQuotation(params.row)}
          >
            {params.row.quotationRefNo}
          </span>
        </div>
      ),
    },
    { field: "customerName", headerName: "Customer Name", width: 200 },
    { field: "initiatorName", headerName: "Initiator Name", width: 300 },
    { field: "SubmittedOn", headerName: "Submit Date", width: 200 },
    {
      field: "status",
      headerName: "Status",
      flex: 0.5,
      sortable: false,
      width: "60px",
      gap: "20px",
      renderCell: (params) => {
        const statusCode = statusMapping[params.row.status] || {};
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <img
              src={statusCode.img}
              alt={statusCode.text}
              width="20"
              height="20"
            />
            <span>{statusCode.text}</span>
          </div>
        );
      },
    },
  ];
  useEffect(() => {
    getTableData(false);
  }, []);

  const handleSnackOpen = (text, type) => {
    setSnackMessage(text);
    setAlertType(type);
    setOpen(true);
  };

  const handleEditQuotation = (users) => {
    setEditQuotation(users);
    setOpenDialog(true);
  };

  //on Load table listing
  function getTableData(isSearch) {
    setIsLoader(true);
    setRows([]);
    setInitialRows([]);

    let inp = {};
    if (!isSearch) {
      inp.refno = "";
      inp.initiator = "";
      inp.customer = "";
      setSelectedValues({
        refno: "",
        initiator: "",
        customer: "",
      });
    } else {
      inp = selectedValues;
    }
    factoryList(
      siteToken,
      azureToken.token,
      UID.id,
      userdetails.userEmail,
      userdetails.roleName,
      userdetails.gid,
      userdetails.roleId,
      inp
    )
      .then((response) => {
        setInitialRows(
          response.map((item, i) => ({
            id: i + 1,
            SubmittedOn: response[i].submittedOn.split("T")[0] || "",
            ...item,
          }))
        );
        setRows(
          response.map((item, i) => ({
            id: i + 1,
            SubmittedOn: response[i].submittedOn.split("T")[0] || "",
            ...item,
          }))
        );
        setIsLoader(false);
      })
      .catch((error) => {
        console.log("Error: " + error, "error");
        setIsLoader(false);
      });
  }

  const handleChange = (field, value) => {
    setSelectedValues((prev) => ({ ...prev, [field]: value }));
  };
  //global search
  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchText(value);
    let filteredRows = {};
    filteredRows = initialRows.filter((row) =>
      Object.values(row).some((field) =>
        field ? field.toString().includes(value) : ""
      )
    );
    setRows(filteredRows);
  };

  //reset global search

  const clearSearch = () => {
    setSearchText("");
    setRows(initialRows);
  };

  //downLoad Excel
  const exportToExcel = () => {
    let ExcelData = [];
    for (let i = 0; i < rows.length; i++) {
      let input = {};
      input.SrNo = i + 1;
      input.Quotation_Ref_No = rows[i].quotationRefNo;
      input.Customer_Name = rows[i].customerName;
      input.Initiator_Name = rows[i].initiatorName;
      input.Submit_Date = rows[i].submittedOn.split("T")[0] || "";
      if (rows[i].status == 1) {
        input.status = "In process / New";
      }
      if (rows[i].status == 2) {
        input.status = "Drawing Pending with AW – design";
      }
      if (rows[i].status == 3) {
        input.status = "Drawing submitted / Completed";
      }

      ExcelData.push(input);
    }
    const worksheet = XLSX.utils.json_to_sheet(ExcelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Upload drawing");
    XLSX.writeFile(workbook, "Upload drawing.xlsx");
  };

  const commonInputStyle = {
    width: "50%",
    padding: "7px",
    marginTop: "14px",
    marginLeft: "8px",

    "& .MuiInputBase-root": {
      fontSize: "12px",
      height: "45px",
    },
  };

  return (
    <>
      <Box sx={{ padding: "10px", border: "1px solid #ccc" }}>
        <Typography variant="h5" gutterBottom>
          Upload Drawing
        </Typography>

        <Grid
          container
          spacing={3}
          style={{ marginTop: "5px", padding: "8px" }}
        >
          <TextField
            sx={{ commonInputStyle }}
            label={
              <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                Quotation Referance No.
              </span>
            }
            name="refno"
            value={selectedValues.refno}
            variant="outlined"
            onChange={(e) => handleChange("refno", e.target.value)}
          />

          <TextField
            sx={{ commonInputStyle }}
            style={{ marginLeft: "15px" }}
            label={
              <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                Initiator Name
              </span>
            }
            name="initiator"
            value={selectedValues.initiator}
            variant="outlined"
            onChange={(e) => handleChange("initiator", e.target.value)}
          />
          <TextField
            sx={{ commonInputStyle }}
            style={{ marginLeft: "15px" }}
            label={
              <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
                Customer Name
              </span>
            }
            name="customer"
            value={selectedValues.customer}
            variant="outlined"
            onChange={(e) => handleChange("customer", e.target.value)}
          />

          <Grid item xs={12} sm={6} md={6} style={{ maxWidth: "none" }}>
            <div>
              <Button
                className="btn"
                variant="contained"
                onClick={() => getTableData(true)}
              >
                Search
              </Button>
              <span style={{ marginLeft: "20px" }}>
                <Button
                  className="btn"
                  variant="contained"
                  onClick={() => getTableData(false)}
                >
                  Reset
                </Button>
              </span>
            </div>
          </Grid>
        </Grid>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "10px",
          }}
        >
          <SearchIcon color="action" />
          <TextField
            variant="standard"
            placeholder="Search"
            value={searchText}
            onChange={handleSearch}
            sx={{ marginLeft: "5px", width: "400px" }}
          ></TextField>
          <IconButton onClick={clearSearch} size="small">
            <ClearIcon fontSize="small" />
          </IconButton>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              marginTop: "20px",
              width: "100%",
            }}
          >
            <Tooltip title="Download excel">
              <IconButton size="small" onClick={exportToExcel}>
                <DownloadIcon />
              </IconButton>
            </Tooltip>

            <UpdateUploadDrawing
              open={openDialog}
              onClose={() => setOpenDialog(false)}
              editQuotation={{ editQuotation }}
            />
          </Box>
        </Box>

        <div
          style={{
            height: 500,
            width: "100%",
            gap: "10px",
            paddingTop: "30px",
          }}
        >
          <DataGrid
            rows={rows}
            columns={columns}
            // getRowId={(row) => row.quotationId}
            getRowId={(row) => row.id}
            pageSize={4}
            rowsPerPageOptions={[4]}
            disableRowSelectionOnClick
            localeText={{
              noRowsLabel: "No Matching Records Found!",
            }}
            loading={isLoader}
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#d3d3d3",
                fontWeight: "500",
                fontSize: "13px",
                color: "black",
                lineHeight: "1.5rem",
              },
              "& .MuiDataGrid-columnHeader": { backgroundColor: "#d3d3d3" },

              "& .MuiDataGrid-cell": {
                textAlign: "left",
                fontSize: "12px",
                display: "flex",
                alignItems: "center",
              },
              "& .MuiDataGrid-footerContainer": {
                fontSize: "12px",
              },
            }}
          />
        </div>
      </Box>
    </>
  );
}
